import { OpacityUpdater } from "./OpacityUpdater";
export async function loadOpacityUpdater(engine) {
  let refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  await engine.addParticleUpdater("opacity", container => new OpacityUpdater(container), refresh);
}